/**
 * useHighlightRitualistRequest Hook
 * Mutation hook for requesting to be highlighted as a ritualist
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import * as connectService from "../services/connect.service"

export function useHighlightRitualistRequest() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: () => connectService.requestHighlightRitualist(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["connect-highlighted-ritualists"] })
      toast.success("Highlight request submitted!")
    },
    onError: (error: { response?: { data?: { message?: string } } }) => {
      toast.error(error.response?.data?.message || "Failed to submit highlight request")
    },
  })

  return mutation
}
